export const NOT_FOUND_ROUTE_QUERY = 'job-offer-not-found';
